import {TEMP_PATH_PART, type TempExpressionPath} from '../shared';

/**
 * Session-local path for the currently-viewed tab in the Designer.
 *
 * This is separate from the persisted `data.tabs.current` which stores the
 * default tab shown on the published site. Clicking a tab in the Designer
 * writes here so other collaborators aren't affected.
 *
 * Session-local — does not sync to other designer sessions because it is in
 * IGNORABLE_TEMP_PATHS (see removeUIOnlyExpressionDiffs.ts).
 */
export const TEMP_TABS_CURRENT_PATH: TempExpressionPath = [
  TEMP_PATH_PART,
  {in: 'Record', at: 'tabs'},
  {in: 'Record', at: 'current'},
];
